import React from "react";
import { FormGroup, Input, Label } from "reactstrap";
import "flatpickr/dist/themes/light.css"
import { Calendar } from "react-feather"
import Flatpickr from "react-flatpickr"
import "../../assets/scss/plugins/forms/flatpickr/flatpickr.scss"

interface IInputDateProp {
    value: Date,
    label: string,
    name: string,
    placeholder?: string,
    id?: string,
    className?: string,
    onChange?: (date: any) => void,
    error?: any
}

interface IInputDateState {
    isTouched: boolean
}

class InputDate extends React.Component<IInputDateProp, IInputDateState> {

    state = {
        isTouched: false
    }

    componentDidMount = () => {
        this.setState({ isTouched: false })
    }

    onChange = (date: any) => {
        if (this.props.onChange)
            this.props.onChange(date);
        this.setState({ isTouched: true });
    }

    render() {
        const { isTouched } = this.state;
        const className = this.props.className || '';
        return (
            <React.Fragment>
                <Label className="d-block" for={this.props.id}>{this.props.label}</Label>
                <FormGroup className="position-relative">
                    <Flatpickr
                        id={this.props.id}
                        name={this.props.name}
                        placeholder={this.props.placeholder}
                        className={`form-control ${className} ${this.props.error && isTouched && "is-invalid"}`}
                        options={{ dateFormat: "Y-m-d" }}
                        value={this.props.value}
                        onChange={(date: any) => this.onChange(date[0])}
                    />
                    <div className="form-control-position">
                        <Calendar size={22} />
                    </div>
                </FormGroup>
                {this.props.error && isTouched && <div className="invalid-tooltip mt-25">{this.props.error}</div>}
            </React.Fragment>
        );
    }
}
export default InputDate;
